import { render, staticRenderFns } from "./ProjectionsModal.vue?vue&type=template&id=55b94641"
import script from "./ProjectionsModal.vue?vue&type=script&lang=js"
export * from "./ProjectionsModal.vue?vue&type=script&lang=js"
import style0 from "./ProjectionsModal.vue?vue&type=style&index=0&id=55b94641&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports